"use client";
import { useSearchBox } from "react-instantsearch";
import type { AutocompleteProps } from "@/components/ui/Autocomplete/Autocomplete";
import { scrollToResults } from "@/components/Blog/BlogSearch/utils";

import BlogAutocomplete from "@/components/Blog/BlogSearch/BlogAutocomplete";
import { debounce } from "lodash";

const BlogAutocompleteForSearch = (props: AutocompleteProps) => {
  const { query, refine, clear } = useSearchBox();

  return (
    <BlogAutocomplete
      {...props}
      query={query}
      onSubmit={({ state }: { state: { query: string } }) => {
        refine(state.query);
        scrollToResults();
      }}
      refine={refine}
      onStateChange={debounce(({ state }: { state: { query: string } }) => {
        if (!state.query) {
          clear();
        }
      }, 300)}
    />
  );
};

export default BlogAutocompleteForSearch;
